// src/store/keycloak.module.js
import {Auth} from '../api';
import * as Storage from '@/core/storage.js';

function getKeycloakConfig() {
    const hostname = window.location.hostname;
    let keycloakBaseUrl = process.env.VUE_APP_KEYCLOAK_URL_BASE;
    let realm = process.env.VUE_APP_KEYCLOAK_REALM;
    let clientId = process.env.VUE_APP_KEYCLOAK_CLIENTID;
    let clientSecret = process.env.VUE_APP_KEYCLOAK_CLIENT_SECRET;

    if (hostname === 'tramites.gruposorah.com') {
        keycloakBaseUrl = process.env.VUE_APP_KEYCLOAK_URL_BASE;
        realm = process.env.VUE_APP_KEYCLOAK_REALM_TEST;
        clientId = process.env.VUE_APP_KEYCLOAK_CLIENTID_TEST;
        clientSecret = process.env.VUE_APP_KEYCLOAK_CLIENT_SECRET_TEST;
    }

    return {keycloakBaseUrl, realm, clientId, clientSecret};
}

export default {
    namespaced: true,
    state: {
        accessToken: Storage.getItem('accessToken') || null,
        refreshToken: Storage.getItem('refreshToken') || null,
        idToken: Storage.getItem('idToken') || null,
        user: Storage.getItem('userKeycloak', {encrypt: false}) || null,
        refreshTimer: null
    },
    mutations: {
        SET_USER(state, payload) {
            state.user = payload.user;
            // Guardamos userKeycloak como objeto (NO encriptado)
            Storage.setItem('userKeycloak', payload.user, {encrypt: false});
        },
        SET_TOKENS(state, {accessToken, refreshToken, idToken, token_expiration, expiresAt}) {
            state.accessToken = accessToken;
            state.refreshToken = refreshToken;
            state.idToken = idToken;
            state.token_expiration = token_expiration;
            state.expiresAt = expiresAt;

            // Guardamos tokens ENCRIPTADOS
            Storage.setItem('accessToken', accessToken); // encrypt default true
            Storage.setItem('refreshToken', refreshToken);
            Storage.setItem('idToken', idToken);
            Storage.setItem('token_expiration', token_expiration, {encrypt: true});
            Storage.setItem('expiresAt', expiresAt, {encrypt: true});
        },
        SET_REFRESH_TIMER(state, timer) {
            if (state.refreshTimer) {
                clearTimeout(state.refreshTimer);
            }
            state.refreshTimer = timer;
        },
        CLEAR_TOKENS(state) {
            state.accessToken = null;
            state.refreshToken = null;
            state.idToken = null;
            state.token_expiration = null;
            state.expiresAt = null;

            Storage.removeItem('accessToken');
            Storage.removeItem('refreshToken');
            Storage.removeItem('idToken');
            Storage.removeItem('token_expiration');
            Storage.removeItem('expiresAt');
            Storage.removeItem('userKeycloak'); // userKeycloak es no encriptado

            if (state.refreshTimer) {
                clearTimeout(state.refreshTimer);
                state.refreshTimer = null;
            }
        }
    },
    actions: {
        logout({commit}) {
            commit('CLEAR_TOKENS');
        },

        async refreshToken({commit, state, dispatch}) {
            try {
                const res = await Auth.refreshTokenWithKeycloak(state.refreshToken);
                const data = res.data;

                const issuedAt = Math.floor(Date.now() / 1000);
                const expiresAt = issuedAt + data.expires_in;

                commit('SET_TOKENS', {
                    accessToken: data.access_token,
                    refreshToken: data.refresh_token,
                    idToken: data.id_token,
                    token_expiration: data.expires_in,
                    expiresAt: expiresAt,
                });

                const refreshInMs = (data.expires_in - 60) * 1000;
                const timer = setTimeout(() => {
                    dispatch('refreshToken');
                }, refreshInMs);

                commit('SET_REFRESH_TIMER', timer);

            } catch (error) {
                console.error('❌ Error al refrescar el token:', error);

                if (error.response?.status === 400 || error.response?.status === 401) {
                    dispatch('logout');

                    const {keycloakBaseUrl, realm} = getKeycloakConfig();
                    const redirectUri = encodeURIComponent(`${window.location.origin}/home`);
                    const token = state.idToken;

                    const logoutUrl = `${keycloakBaseUrl}/realms/${realm}/protocol/openid-connect/logout?id_token_hint=${token}&post_logout_redirect_uri=${redirectUri}`;
                    window.location.href = logoutUrl;
                }
            }
        },

        initRefreshTimer({commit, dispatch}) {
            // Leemos expiresAt y accessToken DESDE Storage (encriptados)
            const expiresAt = Storage.getItem('expiresAt'); // returns number/string or null
            const accessToken = Storage.getItem('accessToken');

            if (!accessToken || !expiresAt) {
                console.log('⚠️ No hay sesión activa, no se programa refresh de token.');
                return;
            }

            const now = Math.floor(Date.now() / 1000);
            const timeUntilExpiration = Number(expiresAt) - now;

            if (timeUntilExpiration > 60) {
                console.log('⏳ Programando refresh de token tras reiniciar...');
                const refreshInMs = (timeUntilExpiration - 60) * 1000;

                const timer = setTimeout(() => {
                    dispatch('refreshToken');
                }, refreshInMs);

                commit('SET_REFRESH_TIMER', timer);

            } else {
                console.warn('⏳ El token está por expirar. Refrescando inmediatamente...');
                dispatch('refreshToken');
            }
        }
    },
    getters: {
        isAuthenticated: state => !!state.accessToken
    }
};